import { combineReducers } from 'redux';
import { reducerApp } from '../App/redux';
import { reducerSystemMessage } from '../common/SystemMessage/redux';

export default combineReducers({ reducerApp, reducerSystemMessage });
